<template>
  <div class="btn-group align-start">
    <!-- "Go to market" cta -->
    <router-link
      v-test:button="'go to market'"
      :to="{
        name: routeNameModalClientEvents,
        params: {
          eventType: 'go-to-market',
          projectId: 'new',
        }
      }"
    >
      <tf-button
        icon="exchange-alt"
        size="large"
        type="secondary"
        @click="$TF.Analytics.trackEvent('Go to market start')"
      >
        Go to market
      </tf-button>
    </router-link>
    <!-- "Collect renewals" cta -->
    <router-link
      v-test:button="'renewal'"
      :tag="canCollectRenewal ? 'a' : 'span'"
      :to="canCollectRenewal
        ? {
          name: routeNameModalClientEvents,
          params: {
            eventType: 'collect-renewals',
            projectId: 'new',
          }
        }
        : {}"
    >
      <tf-button
        :disabled="!canCollectRenewal"
        icon="sync"
        size="large"
        type="primary"
        @click="$TF.Analytics.trackEvent('Collect renewals start')"
      >
        Collect renewals
      </tf-button>
    </router-link>
  </div>
</template>

<script>
  // vuex
  import { mapState } from 'vuex';
  /**
   * 'EmployerBtnGroupEvents' is a component relying on store data to render a set of buttons used to trigger the creation of a "Go to market" or "Renewal" event.
   *
   * @vuedoc
   * @exports Employer/BtnGroupEvents
   * @category Components
   */
  export default {
    name: 'EmployerBtnGroupEvents',
    computed: {
      ...mapState({
        employerInfo: (state) => state.employer.employerInfo,
      }),
      /**
       * Evaluate the employer's current coverages for completed products that are not used in any active events.
       *
       * @returns {boolean}
       */
      canCollectRenewal() {
        if (!this.employerInfo.current_coverage_detail_available) {
          return false;
        }

        return this.$store.state['client/currentCoverages'].data.some(({
          state: productState,
          product_type_id: productTypeId,
        }) => {
          const isInEvent = this.$store.state.activeEvents.activeEvents.some(({ products }) => (
            products.some(({ product_type_id: activeProductTypeId }) => activeProductTypeId === productTypeId)
          ));

          return productState === 'completed' && !isInEvent;
        });
      },
      /**
       * Evaluate the employer info's store data to determine if this client has current coverage details available for this employer to be used in the template.
       *
       * @returns {boolean}
       */
      hasCurrentCoverageDetails() {
        return this.employerInfo.current_coverage_detail_available;
      },
      /**
       * Evaluate the route's name to determine the router-link name to be used in the template.
       *
       * @returns {string}
       */
      routeNameModalClientEvents() {
        const prefix = this.$route.name.startsWith('CoverageHistory') ? 'CoverageHistory' : '';

        return `${prefix}ClientEvents`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    margin: 30px 0;

    > * + * {
      margin-left: $tf-btn-margin-large;
    }
  }
</style>
